import { render, staticRenderFns } from "./CatTable.vue?vue&type=template&id=3729e5fa&scoped=true&"
import script from "./CatTable.vue?vue&type=script&lang=js&"
export * from "./CatTable.vue?vue&type=script&lang=js&"
import style0 from "./CatTable.vue?vue&type=style&index=0&id=3729e5fa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3729e5fa",
  null
  
)

export default component.exports